export interface SharePointSiteStore {
    errorSite?: string;
    isLoading?: boolean;
    isFinished?: boolean;
    responseSite?: SharePointSite;
    searchSite: (value:string) =>  Promise<void>;
}

export interface SharePointListStore {
    errorList?: string;
    isLoading?: boolean;
    isFinished?: boolean;
    responseLists?: SharePointList[];
    searchLists: (value:string) =>  Promise<void>;
}

export interface SharePointSite {
    id: string;
}

export interface SharePointList {
    id: string;
    name: string;
}

export interface GedSharepointListItem {
    title: string,
    idIovision: number,
    typeProject: string,
    contactChefProjet: string,
    contactCommercial: string,
    client: string,
    serviceId: number
    dateProjet: string,
}

export interface WorkspaceResponse {
    data: number
}

export interface WorkspaceStatusResponse {
    idIovision: number
    messageToShow?: string
    buttonToEnable?: string
}

export interface UpdateWorkspaceResponse {
    data: number
}

export interface AccessSharepointListItem {
    requestStatus: string,
    serviceId: number, 
    userList: string[],
    idIovision: string,
}
export interface AccessResponse {
    data: number
}

export interface RequestProjectWorkspaceStore {
    errorRequestProjectWorkspace?: string;
    isLoading?: boolean;
    isFinished?: boolean;
    responseRequestProjectWorkspace?: any;
    requestProjectWorkspace: (value:number, data:any) =>  Promise<void>;
}
export interface RequestProjectAccessStore {
    errorRequestProjectWorkspace?: string;
    isLoading?: boolean;
    isFinished?: boolean;
    responseRequestProjectAccess?: any;
    requestProjectAccess: (value:number, data:any) =>  Promise<void>;
}
export interface UpdateWorkspaceStatusStore {
    errorUpdateWorkspaceStatus?: string;
    isLoading?: boolean;
    isFinished?: boolean;
    responseUpdateWorkspaceStatus?: UpdateWorkspaceResponse;
    updateWorkspaceStatus: (value:number, status: SharepointStatus) =>  Promise<void>;
}

export interface GetWorkspaceStatusStore {
    errorGetWorkspaceStatus?: string;
    isLoading?: boolean;
    isFinished?: boolean;
    responseGetWorkspaceStatus?: WorkspaceStatusResponse;
    getWorkspaceStatus: (value:number) =>  Promise<void>;
}


export enum SharepointStatus {
  PROVISIONED = "Provisionné",
  TO_ARCHIVE = "a archiver",
  TO_RESTORE ="à restaurer",
  ARCHIVED = "Archivé",
  COLD_ARCHIVING = "Archivage froid",
  ARCHIVING_ERROR = "Erreur Archivage"
}